module.exports = __webpack_public_path__ + "media/images/level_introduction4-e25e127af030c4f45f0798ec09ca84e2.png";